import { Component } from "@angular/core";

@Component({
  selector: "icon-ampliacion-seguro-persona",
  templateUrl: "./ampliacion-seguro-persona.svg",
  standalone: true,
})
export class AmpliacionSeguroPersonaComponent {}